export enum InvestingType {
  Individual = "Individual",
  Company = "Company",
}

export enum QuestionType {
  MultiChoice = "MultiChoice",
  CurrencyValue = "CurrencyValue",
  IntegerValue = "IntegerValue",
  FloatValue = "FloatValue",
  Text = "Text",
  MultiValue = "MultiValue",
  Percentage = "Percentage",
  Information = 'Information',
  UploadFile = 'UploadFile',

}


export interface Answer {
  id: string;
  textAr: string;
  textEn: string;
  hasNote: boolean;
  childQuestions: Question[];
  relatedQuestionId?: string;
  isFileUpload?: boolean;
  isBankList?: boolean;
  isIban?: boolean;
  isSelected?: boolean;//only for ui purpose
}
export interface GetRegisterationQuestionsOutputDto {
  categoryId: string,
  categoryNameAr: string,
  categoryNameEn: string,
  questions: Question[],
}
export interface Question {
  id: string;
  titleAr: string;
  titleEn: string;
  questionTypeId: string;
  imageUrl: string | null;
  isMultipleAnswer: boolean;
  isMandatory: boolean;
  answers: Answer[] | null;
  isCountryQuestion: boolean;
  childQuestions?: Question[]; // Add this to support nested questions
}
export interface Category {
  categoryId: string;
  categoryNameAR: string;
  categoryNameEN: string;
  questions: Question[];
}

export interface QuestionsResponse {
  questionId?: string;
  questionTypeId?: string;
  textAnswer?: string | undefined;
  numericAnswer?: number | 0;
  answerId?: string | undefined;
  answers?: QuestionsResponse[]

}
export interface SubmitKYCAnswersInputDto {
  singleAnswerList: QuestionsResponse[],
  multiAnswersList: QuestionsResponse[],
  investorSignature?: string,

}
export interface UploadKycInputDto {
  "fileBase64": string,
  "fileExtention": string,
}
export interface KYCAnswerDetailsResponse{
  categorizedAnswers:DashUserAnswersDto[],
 investorSignature?:string,
 requestId?:string,
}
export interface DashUserAnswersDto{
  categoryId:string,
categoryNameAr:string
categoryNameEn:string,
answers:KYCUserAnswersDto[]

}
export interface KYCUserAnswersDto {
  questionId: string; // Guid type in C# maps to string in TypeScript
  questionTypeId: QuestionType; // Enum type should be kept as is
  questionTitleAr: string;
  questionTitleEn: string;
  answersList: AnswersListDto[]; // List<T> in C# maps to an array in TypeScript
}
export interface AnswersListDto {
  userAnswerId: string; // Guid type in C# maps to string in TypeScript
  answerTextAr: string|null;
  answerTextEn: string|null;
  statusId: UserAnswerStatus; // Enum type should be kept as is
  numericAnswer?: number|null; // Nullable decimal in C# becomes optional number in TypeScript
  textAnswer: string|null;
  isFileUpload?:boolean|null;
}
export enum UserAnswerStatus {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
  ReSubmit=3,
}